// client/nodes/headings.ts
import "@adornis/chemistry/elements/components/x-icon";
import { inputRules, textblockTypeInputRule } from "prosemirror-inputrules";
import { HEADING_KEY, HEADING_SCHEMA } from "../../schema/nodes/heading.js";
import { MenuItemGroup } from "../types.js";
import { isInHeading, isInParagraph } from "../util.js";
var heading = () => ({
  node: {
    name: HEADING_KEY,
    schema: HEADING_SCHEMA()
  },
  menuItems: [
    createHeadingMenuItem(1),
    createHeadingMenuItem(2),
    createHeadingMenuItem(3),
    createHeadingMenuItem(4),
    createHeadingMenuItem(5)
  ],
  plugins: (schema) => [
    inputRules({
      rules: [
        // Use the existing headingRule function which handles # to ##### markdown syntax
        ...schema.nodes.heading ? [headingRule(schema.nodes.heading)] : []
      ]
    })
  ]
});
function createHeadingMenuItem(level) {
  const icon = `format_h${level}`;
  return {
    group: MenuItemGroup.HEADINGS,
    label: `\xDCberschrift ${level}`,
    icon,
    run: (view) => {
      toggleHeading(level, view)(view.state, view.dispatch);
    },
    shouldVisualize: (view) => {
      return isInParagraph(view.state) || isInHeading(view.state);
    },
    isActive: (view) => {
      return toggleHeading(level, view)(view.state);
    }
  };
}
function headingRule(nodeType) {
  return textblockTypeInputRule(/^(#{1,6})\s$/, nodeType, (match) => ({
    level: match[1] ? match[1].length : 1
    // Fallback to level 1 if match[1] is undefined
  }));
}
function toggleHeading(level, view) {
  return (state, dispatch) => {
    const { schema, selection } = state;
    const headingType = schema.nodes.heading;
    const paragraphType = schema.nodes.paragraph;
    if (!headingType || !paragraphType)
      return false;
    const { from, to } = selection;
    let isActive = true;
    state.doc.nodesBetween(from, to, (node) => {
      if (node.type === headingType && node.attrs.level === level)
        return false;
      isActive = false;
      return true;
    });
    if (dispatch) {
      const tr = state.tr;
      if (isActive) {
        tr.setBlockType(from, to, paragraphType);
      } else {
        tr.setBlockType(from, to, headingType, { level });
      }
      dispatch(tr);
      view.focus();
    }
    return isActive;
  };
}
export {
  heading,
  headingRule
};
